import { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";
import { markInternalDevice } from "@/lib/tracking/posthog";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pb24_token");
    if (!token) {
      setLoading(false);
      return;
    }
    client
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("pb24_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  // Team-Geräte aus der Statistik nehmen, sobald jemand im Admin angemeldet ist
  useEffect(() => { if (user) markInternalDevice(); }, [user]);

  const finish = (data) => {
    localStorage.setItem("pb24_token", data.token);
    setUser(data.user);
    return data.user;
  };

  // Liefert bei aktivierter Zwei-Faktor-Anmeldung { requires2fa: true, preToken } statt des Nutzers (26.10.2026)
  const login = async (email, password, rememberMe = false) => {
    const r = await client.post("/auth/login", { email, password, remember_me: rememberMe });
    if (r.data?.requires_2fa) return { requires2fa: true, preToken: r.data.pre_token };
    return finish(r.data);
  };

  const verify2fa = async (preToken, code) => {
    const r = await client.post("/auth/2fa/verify", { pre_token: preToken, code });
    return finish(r.data);
  };

  const logout = () => {
    localStorage.removeItem("pb24_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, verify2fa, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
